var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconoinfoblanco(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_2",
    "data-name": "Capa 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 66.08 66.08",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Eventos_seleccionado",
    "data-name": "Eventos seleccionado"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m33.04,66.08C14.82,66.08,0,51.26,0,33.04S14.82,0,33.04,0s33.04,14.82,33.04,33.04-14.82,33.04-33.04,33.04Zm0-63.42C16.29,2.66,2.66,16.29,2.66,33.04s13.63,30.38,30.38,30.38,30.38-13.63,30.38-30.38S49.79,2.66,33.04,2.66Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m23.54,30.88l12.92-4.32c1.02-.34,2.14-.1,2.93.62h0c1.1,1,1.29,2.65.45,3.87l-11.2,16.31c-.61.89-.16,2.11.87,2.4h0c.38.11.79.06,1.15-.12l7.2-3.36c.23-.11.5,0,.59.24h0c.07.19,0,.4-.16.51l-7.75,5.46c-2.09,1.49-4.9,1.52-7.02.07h0c-2.75-1.89-3.49-5.63-1.65-8.42l6.47-9.83c.67-1.01-.1-2.35-1.31-2.3l-3.25.15c-.21,0-.4-.08-.54-.24h0c-.29-.35-.14-.89.3-1.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m43.72,20.29c-1.94,2.42-5.02,3.17-6.88,1.68-1.86-1.49-1.79-4.66.16-7.08,1.94-2.42,5.02-3.17,6.88-1.68,1.86,1.49,1.79,4.66-.16,7.08Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconoinfoblanco);
export default __webpack_public_path__ + "static/media/icono info blanco.4d91bf891edd1d294eaa646d1bac190c.svg";
export { ForwardRef as ReactComponent };